import JoyDeal from '../objects/JoyDeal';
import JoyPhotosession from '../objects/JoyPhotosession';
export function isJoyDeal(value) {
    return (value instanceof JoyDeal);
}
export function isJoyPhotosession(value) {
    return (value instanceof JoyPhotosession);
}
//# sourceMappingURL=ModelValidation.js.map